import React, { Component } from "react";
import _ from "lodash";
import ReactCrop from "react-image-crop";
import 'react-image-crop/dist/ReactCrop.css';
import { Row, Col } from "react-bootstrap";
import { Box, Button, Dialog, DialogTitle, DialogActions, DialogContent } from "@material-ui/core";
// import Camera from "../../common/assets/camera.png";
//import CameraWhite from "../../common/assets/camera-white.png";
import CameraWhite from "../common/assets/logo.png";

const styles = {
  raisedStyle: {
    borderRadius: 45,
    height: 40,
    borderWidth: 1,
    marginRight: 20,
    marginBottom: 15
  },
  buttonStyle: {
    borderRadius: 45,
    paddingLeft: 20,
    paddingRight: 20
  },
  raisedLabel: {
    fontSize: 13,
    fontWeight: 300,
    textTransform: "none",
    fontFamily: "'Open Sans', sans-serif"
  },
  imgProfile: {
    width: 300,
    height: 300,
    borderRadius: "50%",
    zIndex: 99,
    borderStyle: "solid",
    borderWidth: 5,
    borderColor: "rgba(151, 151, 151, 0.8)",
    objectFit: "contain"
    // marginLeft: 20
  },
  iconPet: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: 144,
    height: 144,
    borderRadius: "50%",
    zIndex: 99,
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "rgba(255, 255, 255, 0.8)",
    backgroundColor: "#f7f7f7"
    // marginLeft: 20
  },
  imgProfileRectangle: {
    width: "100%",
    height: "100%",
    borderRadius: "6",
    zIndex: 99,
    borderStyle: "solid",
    borderWidth: 2,
    borderColor: "#0091d4",
    // objectFit: "contain"
    // borderColor: "rgba(151, 151, 151, 0.8)",
    // marginLeft: 20
  },
  iconPetRectangle: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: 300,
    height: 150,
    borderRadius: 6,
    zIndex: 99,
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "rgba(255, 255, 255, 0.8)",
    backgroundColor: "#f7f7f7"
    // marginLeft: 20
  },
  labelPhoto: {
    width: 204,
    height: 42,
    borderBottomRightRadius: 45,
    borderTopRightRadius: 45,
    boxShadow: "0 2px 2px 0 rgba(0, 0, 0, 0.24), 0 0 2px 0 rgba(0, 0, 0, 0.12)",
    backgroundColor: "#fff",
    borderStyle: "solid",
    borderWidth: 2,
    borderColor: "#0091d4",
    display: "flex",
    alignItems: "center",
    paddingLeft: 5
  },
  label: {
    fontSize: 12,
    fontWeight: 400,
    textTransform: "none",
    fontFamily: "'Open Sans', sans-serif",
    color: "rgba(0, 0, 0, 0.38)"
  },
  labelNoPhoto: {
    width: 204,
    height: 42,
    borderBottomRightRadius: 45,
    borderTopRightRadius: 45,
    boxShadow: "0 2px 2px 0 rgba(0, 0, 0, 0.24), 0 0 2px 0 rgba(0, 0, 0, 0.12)",
    backgroundColor: "#fff",
    borderStyle: "solid",
    borderWidth: 2,
    borderColor: "#0091d4",
    display: "flex",
    alignItems: "center",
    paddingLeft: 10
  }
};

class Crop extends Component {
  constructor(props) {
    super(props);
    this.state = {
      src: null,
      crop: this.props.crop,
      fileName: "No se eligió un archivo"
    };
  }

  handleClose = () => {
    this.setState({
      src: null,
      crop: this.props.crop,
      open: false,
      croppedImageUrl: null,
      fileName: "No se eligió un archivo"
    });
    this.props.handleClose();
  };

  handleConfirm = () => {
    let { imgBlob, croppedImageUrl } = this.state;
    this.setState({
      src: null,
      crop: this.props.crop,
      open: false,
      croppedImageUrl: null,
      fileName: "No se eligió un archivo"
    });
    this.props.handleConfirm(imgBlob, croppedImageUrl);
  };

  onSelectFile = e => {
    // console.log("onSelectFile 1");
    if (e.target.files && e.target.files.length > 0) {
      // console.log("onSelectFile 2");
      // console.log("fileName 1", e.target.files[0].name);
      // console.log("fileName 2", e.target.value.split("\\").pop());
      const reader = new FileReader();
      reader.addEventListener("load", () =>
        this.setState({ src: reader.result })
      );
      reader.readAsDataURL(e.target.files[0]);
      this.setState({ fileName: e.target.files[0].name });
    }
  };

  onImageLoaded = (image, pixelCrop) => {
    // console.log("onImageLoaded");
    this.imageRef = image;
  };

  onCropComplete = (crop, pixelCrop) => {
    // console.log("onCropComplete");
    this.makeClientCrop(crop, pixelCrop);
  };

  onCropChange = crop => {
    // console.log("onCropChange");
    this.setState({ crop });
  };

  async makeClientCrop(crop, pixelCrop) {
    // console.log("makeClientCrop 1");
    if (this.imageRef && crop.width && crop.height) {
      // console.log("makeClientCrop 2");
      const imgBlob = await this.getCroppedImg(
        this.imageRef,
        pixelCrop,
        "newFile.jpeg"
      );
      window.URL.revokeObjectURL(this.fileUrl);
      this.fileUrl = window.URL.createObjectURL(imgBlob);
      this.setState({ croppedImageUrl: this.fileUrl, imgBlob });
    }
  }

  getCroppedImg(image, pixelCrop, fileName) {
    // console.log("fileName", fileName);
    const canvas = document.createElement("canvas");
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = pixelCrop.width;
    canvas.height = pixelCrop.height;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      image,
      pixelCrop.x * scaleX,
      pixelCrop.y * scaleY,
      pixelCrop.width * scaleX,
      pixelCrop.height * scaleY,
      0,
      0,
      pixelCrop.width,
      pixelCrop.height
    );

    return new Promise((resolve, reject) => {
      canvas.toBlob(blob => {
        if (!blob) {
          //reject(new Error('Canvas is empty'));
          console.error("Canvas is empty");
          return;
        }
        blob.name = fileName;
        resolve(blob);
      }, "image/jpeg");
    });
  }

  render() {
    const { crop, croppedImageUrl, src } = this.state;
    const { rectangle, toggle } = this.props;
    const actions = [
      <Box
        className="custom-input-file display-flex left1"
        style={{ justifyContent: "space-between" }}
      >
        <div className="display-flex">
          <input
            type="file"
            onChange={this.onSelectFile}
            accept="image/x-png,image/gif,image/jpeg"
            id="file"
          />
          <label for="file">
            <img
              src={CameraWhite}
              style={{
                width: "auto",
                height: 16,
                marginRight: 10,
                marginBottom: 2
              }}
              alt=""
            />
            Seleccionar
          </label>
          <div
            style={
              this.state.fileName === "No se eligió un archivo"
                ? styles.labelNoPhoto
                : styles.labelPhoto
            }
          >
            {_.size(this.state.fileName) > 25
              ? this.state.fileName.substring(0, 23) + "..."
              : this.state.fileName}
          </div>
        </div>
        <div className="flex-column justify-content-start">{toggle}</div>
        <div style={{ justifyContent: "space-around" }}>
          <Button
            onClick={this.handleClose}
            style={styles.raisedStyle}
            buttonStyle={styles.buttonStyle}
            overlayStyle={styles.buttonStyle}
            labelStyle={styles.raisedLabel}
            secondary={true}
          >
            Cancelar
          </Button>
          <Button
            style={styles.raisedStyle}
            buttonStyle={styles.buttonStyle}
            overlayStyle={styles.buttonStyle}
            labelStyle={styles.raisedLabel}
            primary={true}
            onClick={this.handleConfirm}
            disabled={toggle ? false : !croppedImageUrl}
          >
            Aceptar
          </Button>
        </div>
      </Box>
    ];
    console.log("IMG", src, croppedImageUrl)
    return (
      <Dialog
        open={this.props.open}
      >
        <DialogTitle style={{color: "#0091d4"}}>Selecciona una imagen</DialogTitle>
        <DialogContent >
        <Box
          style={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "center"
          }}
        >
        {src && (
          <Box xs={6} sm={6} md={6}>
            <div className="bottom10" style={styles.label}>
              Ajuste el cuadro en la parte que desea mostrar
          </div>
            <ReactCrop
              src={src}
              crop={crop}
              onImageLoaded={this.onImageLoaded}
              onComplete={this.onCropComplete}
              onChange={this.onCropChange}
            />
          </Box>
        )}
        {croppedImageUrl ? (
          <Box>
            <div className="bottom10" style={styles.label}>
              Previsualización
           </div>
            <img
              src={croppedImageUrl}
              style={
                rectangle ? styles.imgProfileRectangle : styles.imgProfile
              }
              alt=""
            />
          </Box>
        ) : 
          null}
      </Box>
    </DialogContent>
    <DialogActions>
      {actions}
    </DialogActions>
</Dialog >
 );
  }
}

Crop.defaultProps = {
  crop: { aspect: 1, width: 50, x: 0, y: 0 }
};

export default Crop;


// WEBPACK FOOTER //
// ./src/components/Crop.js